<template>
  <view-panel title="今日访客趋势" class="pv-trend">
    <c-tooltip
      class="title-tip"
      slot="title"
      v-if="store && !showEmpty"
      :content="tongbiTip"
      placement="bottom"
    >
      <span :style="{ color: /^-/.test(store.tongbi) ? '#29bd76' : '#f55858' }">
        <i
          :class="
            /^-/.test(store.tongbi)
              ? 'icon-arrow_glyph_down'
              : 'icon-arrow_glyph_up'
          "
        ></i
        >{{ store.tongbi.replace('-', '') }}%
      </span>
    </c-tooltip>
    <div class="line-chat" ref="toChart"></div>
    <div class="empty-tip" v-if="showEmpty">暂无数据</div>
    <c-loading v-if="!store"></c-loading>
  </view-panel>
</template>

<script>
import viewPanel from './panel'
import echarts from 'echarts'
import constants from './constants'
let chart = null
export default {
  name: 'overviewPvTrend',
  components: {
    viewPanel
  },
  props: {
    store: null
  },
  computed: {
    tongbiTip () {
      if (!this.store) return '-'
      let value = this.store.tongbi
      let date = new Date(new Date().getTime() - this.$util.dayTime * 8)
      let yesterday = new Date(new Date().getTime() - this.$util.dayTime)
      return `${this.$util.dateFormat(
        yesterday,
        'mm月dd日'
      )}和${this.$util.dateFormat(date, 'mm月dd日')}对比${
        value > 0 ? '上升' : '下降'
      }了${value.replace('-', '') || '-'}%`
    },
    showEmpty () {
      if (!this.store) return false
      let empty = true
      this.store.series.forEach(item => {
        if (item.values && item.values.length) empty = false
      })
      return empty
    }
  },
  watch: {
    store (store) {
      if (!store) return
      const option = {
        color: constants.color,
        grid: {
          top: 10,
          bottom: 20,
          left: 50
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#DADADA'
            }
          },
          axisLabel: {
            color: '#333333'
          },
          splitNumber: 4,
          data: store.xAxis
        },
        yAxis: {
          type: 'value',
          splitNumber: 3,
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          formatter (params) {
            const map = {}
            params.forEach(series => {
              map[series.seriesName] = series
            })
            const lines = ['今日', '昨日', '历史7日均值'].map((name, i) => {
              const maker = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${
                constants.color[i]
              };"></span>`
              if (map[name]) {
                return `${maker} ${name}: ${map[name].value}`
              } else {
                return `${maker} ${name}: -`
              }
            })
            return `${params[0].name}<br/>${lines.join('<br/>')}`
          }
        },
        series: store.series.map((series, i) => {
          const name = series.names.join('-')
          const lineStyle =
            name === '今日'
              ? {
                width: 2
              }
              : {
                type: 'dashed',
                width: 1
              }
          lineStyle.color = constants.color[i]
          return {
            type: 'line',
            name,
            data: series.values.map((v, j) => {
              let symbolSize = 0
              if (!/\d/.test(v)) return { value: v, symbolSize }
              if (j === 0 && !/\d/.test(series.values[j + 1])) {
                symbolSize = 4
              } else if (
                j === series.values.length - 1 &&
                !/\d/.test(series.values[j - 1])
              ) {
                symbolSize = 4
              } else if (
                !/\d/.test(series.values[j + 1]) &&
                !/\d/.test(series.values[j - 1])
              ) {
                symbolSize = 4
              }
              return {
                value: v,
                symbolSize
              }
            }),
            lineStyle
          }
        })
      }
      chart.setOption(option)
    }
  },
  mounted () {
    chart = echarts.init(this.$refs.toChart)
  },
  beforeDestroy () {
    chart.dispose()
    chart = null
  }
}
</script>

<style lang="sass">
@import '../../assets/constants'
.pv-trend
  .empty-tip
    background: #fff
  .title-tip
    font-size: $size-font-content-medium
    float: right
    i
      margin-right: 5px
  .line-chat
    height: 100%
</style>
